import { render, staticRenderFns } from "./version_control.vue?vue&type=template&id=6b19c86e&"
import script from "./version_control.vue?vue&type=script&lang=js&"
export * from "./version_control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports